import React from 'react'

function Receipts() {
  return (
    <div>Receipts</div>
  )
}

export default Receipts